const config = {
    development: {
        activationEndpoint: 'http://localhost:8000/api-auth-djoser/users/activation/',
        loginEndpoint: "http://localhost:8000/api/login/",
        logoutEndpoint: "http://localhost:8000/api-auth-djoser/token/logout/",
        myUserEndpoint: "http://localhost:8000/api-auth-djoser/users/me/",
        registerEndpoint: "http://localhost:8000/api-auth-djoser/users/",
        twoFALoginEndpoint: "http://localhost:8000/api/2fa/login/",
        resetPasswordEndpoint: "http://localhost:8000/api-auth-djoser/users/reset_password/",
        resetPasswordConfirmEndpoint: "http://localhost:8000/api-auth-djoser/users/reset_password_confirm/",
        getProfileEndpoint: (userId) => `http://localhost:8000/api/profiles/${userId}/`,
        getProfileUpdateEndpoint: (userId) => `http://localhost:8000/api/profiles/${userId}/update/`,
        
        // Adat lekérési végpontok
        geologicalEndpoint: "http://localhost:8000/api/geological/",
        parishEndpoint: (page = 1) => `http://localhost:8000/api/kozsegvaros/?page=${page}`,
        telepulesEndpoint: (page = 1) => `http://localhost:8000/api/telepules/?page=${page}`,
        szekEndpoint: (page = 1) => `http://localhost:8000/api/szek/?page=${page}`,
        megyeEndpoint: (page = 1) => `http://localhost:8000/api/megye/?page=${page}`,
        helynevEndpoint: (page = 1) => `http://localhost:8000/api/helynev/?page=${page}`,
        mineralWaterEndpoint: "http://localhost:8000/api/mineral_waters/",
        getMineralWaterInfoEndpoint: (category, id) => `http://localhost:8000/api/mineral_waters/${category}/${id}/`,
        requestMembershipEndpoint: "http://localhost:8000/api/request-szft-membership/",
        refreshTokenEndpoint: "http://localhost:8000/api/token/refresh/",
        approveMembershipEndpoint: (userId, token) => `http://localhost:8000/api/approve-membership/${userId}/${token}/`,
        rejectMembershipEndpoint: (userId, token) => `http://localhost:8000/api/reject-membership/${userId}/${token}/`,
        szekelyfoldAlapterkepTiles: "https://www.sznoapi.ro/tiles/nsznhonismereti/{z}/{x}/{y}.png",
        herbichGeoTiles: "https://www.sznoapi.ro/tiles/herbichgeo/{z}/{x}/{y}.png",
        nsznHonismeretiTiles: "https://www.sznoapi.ro/tiles/nsznhonismereti/{z}/{x}/{y}.png",
        geo200000Tiles: "https://www.sznoapi.ro/tiles/geo200000/{z}/{x}/{y}.png",
        cyclOSMTiles: "https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
        osmTiles: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        gsstDomborzatTiles: "https://www.sznoapi.ro/tiles/gsst/{z}/{x}/{y}.png",
        meetingsEndpoint: "http://localhost:8000/api/meetings/",
        meetingsUploadEndpoint: "http://localhost:8000/api/meetings/upload/",
    },
    production: {
        activationEndpoint: 'https://www.sznoapi.ro/api-auth-djoser/users/activation/',
        loginEndpoint: "https://www.sznoapi.ro/api/login/",
        logoutEndpoint: "https://www.sznoapi.ro/api-auth-djoser/token/logout/",
        myUserEndpoint: "https://www.sznoapi.ro/api-auth-djoser/users/me/",
        registerEndpoint: "https://www.sznoapi.ro/api-auth-djoser/users/",
        twoFALoginEndpoint: "https://www.sznoapi.ro/api/2fa/login/",
        resetPasswordEndpoint: "https://www.sznoapi.ro/api-auth-djoser/users/reset_password/",
        resetPasswordConfirmEndpoint: "https://www.sznoapi.ro/api-auth-djoser/users/reset_password_confirm/",
        getProfileEndpoint: (userId) => `https://www.sznoapi.ro/api/profiles/${userId}/`,
        getProfileUpdateEndpoint: (userId) => `https://www.sznoapi.ro/api/profiles/${userId}/update/`,

        // Adat lekérési végpontok
        geologicalEndpoint: "https://www.sznoapi.ro/api/geological/",
        parishEndpoint: (page = 1) => `https://www.sznoapi.ro/api/kozsegvaros/?page=${page}`,
        telepulesEndpoint: (page = 1) => `https://www.sznoapi.ro/api/telepules/?page=${page}`,
        szekEndpoint: (page = 1) => `https://www.sznoapi.ro/api/szek/?page=${page}`,
        megyeEndpoint: (page = 1) => `https://www.sznoapi.ro/api/megye/?page=${page}`,
        helynevEndpoint: (page = 1) => `https://www.sznoapi.ro/api/helynev/?page=${page}`,
        mineralWaterEndpoint: "https://www.sznoapi.ro/api/mineral_waters/",
        getMineralWaterInfoEndpoint: (category, id) => `https://www.sznoapi.ro/api/mineral_waters/${category}/${id}/`,
        requestMembershipEndpoint: "https://www.sznoapi.ro/api/request-szft-membership/",
        refreshTokenEndpoint: "https://www.sznoapi.ro/api/token/refresh/",
        approveMembershipEndpoint: (userId, token) => `https://www.sznoapi.ro/api/approve-membership/${userId}/${token}/`,
        rejectMembershipEndpoint: (userId, token) => `https://www.sznoapi.ro/api/reject-membership/${userId}/${token}/`,
        szekelyfoldAlapterkepTiles: "https://www.sznoapi.ro/tiles/nsznhonismereti/{z}/{x}/{y}.png",
        herbichGeoTiles: "https://www.sznoapi.ro/tiles/herbichgeo/{z}/{x}/{y}.png",
        nsznHonismeretiTiles: "https://www.sznoapi.ro/tiles/nsznhonismereti/{z}/{x}/{y}.png",
        geo200000Tiles: "https://www.sznoapi.ro/tiles/geo200000/{z}/{x}/{y}.png",
        cyclOSMTiles: "https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
        osmTiles: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        gsstDomborzatTiles: "https://www.sznoapi.ro/tiles/gsst/{z}/{x}/{y}.png",
        meetingsEndpoint: "https://www.sznoapi.ro/api/meetings/",
        meetingsUploadEndpoint: "https://www.sznoapi.ro/api/meetings/upload/",
    }
};

// CORS issue notice: 
// If you see CORS errors in production, ensure that the domain where this app is hosted 
// (e.g., https://szft.ro) is added to the backend's allowed origins list 
// (CORS_ALLOWED_ORIGINS in Django's settings.py).

export default config;
export const environment = process.env.NODE_ENV === 'production' ? 'production' : 'development';
